import API_ENDPOINTS from '../../../api/endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { BaseResponse } from '../UtilsInterface';
import {
  InquiryData,
  InquiryResponse,
  InquiryToSellerBody,
} from '../InquiryInterfaces';

// 구매자 문의하기 서비스 정의
const BuyerInquiryService = {
  // 문의 이력 조회
  getInquiriesList: async (
    page: number,
    size: number
  ): Promise<InquiryResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_buyer_inquiry_list(page, size)
      );
      return response.data;
    } catch (error) {
      console.error('문의 이력 조회 실패:', error);
      throw error;
    }
  },

  // 판매자에게 문의 등록
  postInquiryToSeller: async (
    payload: InquiryToSellerBody
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.post_buyer_inquiry_to_seller(),
        payload
      );
      return response.data;
    } catch (error) {
      console.error('판매자에게 문의 등록 실패:', error);
      throw error;
    }
  },

  // 문의 상세 조회
  getInquiryDetail: async (
    inquiryId: string
  ): Promise<BaseResponse<InquiryData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_buyer_inquiry_detail(inquiryId)
      );
      return response.data;
    } catch (error) {
      console.error('문의 상세 조회 실패:', error);
      throw error;
    }
  },
};

export default BuyerInquiryService;
